module.exports = __webpack_public_path__ + "static/media/mercedes-banner-image2.816209e0.png";